import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import FailureCodeListLayer from "../components/FailureCodeListLayer";

const FailureCodePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Failure Codes">
        {/* FailureCodeListLayer */}
        <FailureCodeListLayer />
      </MasterLayout>
    </>
  );
};

export default FailureCodePage;
